import React, { useEffect, useState } from 'react';
import { Panel, MTable, Container, PaginationTable, Pagination } from '../../../../Components';
import { FormControl, Grid,TextField,Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { SelectDropDown } from '../../../../Components/Select/SelectDropDown';
import { MTableToolbar } from '@material-table/core';
import { useStyles } from './User.styles';
import UserSevicesApi from '../../../../Redux/Actions/UserAction';
import { useDispatch, useSelector } from 'react-redux';
import { useApiValidationSnackbar } from '../../../../Components/Snackbar/SnackbarAlert';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { MenuItem, Select } from '@mui/material';
export const UserListCustomer = () => {
  const { userList, apiToken, currentUser, allCustomers,updatedUser} = useSelector((state: any) => ({
    userList: state?.UserReducer?.userList,
    apiToken: state?.UserReducer?.apiToken,
    currentUser: state?.UserReducer?.currentUser,
    allCustomers: state?.CustomerReducer?.allCustomers,
    updatedUser:state?.UserReducer?.updatedUser,
  }))
  const alluser = [{id:currentUser?.customerId, companyName: 'allUser', organisationId: '7777', email: 'AllUser@gmail.com', mobile: '54646468'}]
  const { formatMessage } = useIntl();
  const tableRef = React.createRef();
  const [customer, setCustomer] = useState<any>(alluser);
  let [allCustomer,setAllCustomer] = useState(allCustomers==undefined?[]:allCustomers)
  let [selected, setSelected] = useState<any>(currentUser?.customerId);
  const [reloadPage,setReload] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch: any = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const {ErrorMessage} = useApiValidationSnackbar();
  const classes = useStyles()
  useEffect(() => {
    if(userList==undefined){
      navigate('/')
    }
    try {
      dispatch(UserSevicesApi?.UserListData(selected, apiToken,enqueueSnackbar));
    } catch (error) {
      let internalError:any = 'internalError'
      ErrorMessage( userList,internalError)
    }
    if(customer[0].id == currentUser?.customerId){
      setCustomer((customer:any) => [...customer, ...allCustomer]);
    }
  }, [])
  const bodydata:any = [
    { title: formatMessage({id:"customer.table.companyName",defaultMessage:"Company name"}), field: "companyName",editable:()=>{return false} },
    { title: formatMessage({ id: "customer.create.firstName", defaultMessage: "First name" }), field: "firstName" },
    { title: formatMessage({ id: "customer.create.lastName", defaultMessage: "Last name" }), field: "lastName" },
    { title: formatMessage({ id: "users.table.email", defaultMessage: "Email" }), field: "email",editable:()=>{return false} },
    {
      title: formatMessage({ id: "users.table.role", defaultMessage: "Role" }),
      field: "role",
      lookup: {
        "Admin": formatMessage({ id: "form.roll.Admin", defaultMessage: "Admin" }),
        "ClientAdmin": formatMessage({ id: "form.roll.clientAdmin", defaultMessage: "ClientAdmin" }),
        "User": formatMessage({ id: "form.user", defaultMessage: "User" })
      },
      editable: (row: any, rowData: any) => {
        // Make 'Admin' non-editable and ensure the current user can't edit their own row
        return rowData.role !== "Admin" && rowData.id !== currentUser?.id;
      },
      editComponent: (props: any) => {
        const editLookup = {
          "ClientAdmin": formatMessage({ id: "form.roll.clientAdmin", defaultMessage: "ClientAdmin" }),
          "User": formatMessage({ id: "form.user", defaultMessage: "User" })
        };
    
        return (
          <TextField
            select
            value={props.value || ""}
            className='role-select'
            onChange={(e) => props.onChange(e.target.value)}
            variant="outlined" 
            SelectProps={{
              MenuProps: {
                anchorOrigin: {
                  vertical: "bottom", 
                  horizontal: "left"
                },
                transformOrigin: {
                  vertical: "top", 
                  horizontal: "left"
                },
                getContentAnchorEl: null
              }
            }}
          >
            {Object.entries(editLookup).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        );
      }
    },
    { title: formatMessage({ id: "users.table.status", defaultMessage: "Status" }), field: "status",editable: ()=>{return false}, lookup:{"Active":formatMessage({ id: "status.active", defaultMessage: "Active" }),"Pending":formatMessage({ id: "status.pending", defaultMessage: "Pending" }),"Expired":formatMessage({ id: "status.expire", defaultMessage: "Expired" })}},
  ]
  const onhandleChange = (event: any) => {
    setSelected(event?.target?.value)
    let customerId:any = event?.target?.value;
    dispatch(UserSevicesApi?.UserListData(customerId, apiToken,enqueueSnackbar));
  }
  const {pagination,toolbar,body,header} = Pagination();
  const activation = (user:any) => (
    {
      tooltip: user?.isDeleted == true ? formatMessage({ id: 'component.mtable.activateTooltip' }) : formatMessage({ id: "component.mtable.inactivateTooltip" }),
      icon: user?.isDeleted == true ? 'check' : 'block',
      disabled: user?.status != 'Active' || currentUser?.id == user?.id ? true : false,
      onClick: async () => {
        setReload(true)
        dispatch(UserSevicesApi?.deleteUser(user?.id, apiToken, enqueueSnackbar))
        setTimeout(() => {
          dispatch(UserSevicesApi?.UserListData(currentUser?.customerId, apiToken, enqueueSnackbar));
          setReload(false)
        }, 1500);
      },
    })
  return (
    <Container fullWidth>
      <Grid item className='userList-container'>
        <Panel titleKey="organization.users">
          <MTable
            tableRef={tableRef}
            columns={bodydata} data={userList?.length == undefined?[]:userList}
            actions={[activation]}
            isLoading={reloadPage}
            onPageChange={(page)=>setPage(page)}
            onRowsPerPageChange={(pageSize:any)=> setRowsPerPage(parseInt(pageSize, 10))}
            localization={{pagination,toolbar,body,header}}
            editable={{
              isEditable : (rowdata:any) => rowdata?.role == 'Admin' ? false : true,
              onRowUpdate:(newData:any) =>
              new Promise((resolve)=>{
                const userData ={
                  email:newData?.email,
                  firstName:newData?.firstName,
                  lastName:newData?.lastName,
                  role:newData?.role
                  }
                  let statusEdit:any = "statusEdit"
                  if(newData?.status != 'Active'){
                    ErrorMessage(userList,statusEdit)
                    resolve(updatedUser)
                  }else{
                  setReload(true)
                  dispatch(UserSevicesApi.userUpdate(newData?.id,userData, apiToken,enqueueSnackbar));
                  setTimeout(() => {
                  dispatch(UserSevicesApi.UserListData(newData?.customerId, apiToken,enqueueSnackbar));
                    setReload(false)
                  resolve(updatedUser)
                }, 2000)
              }
              }),
            }}
            components={{
              Pagination: (props: any) => (
                <Grid component="td" container justifyContent="space-between">
                  <Grid item>
                    <Typography className={classes.total}>
                      {formatMessage({ id: 'component.mtable.total' })}
                      &nbsp;{userList?.length}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} >
                    <PaginationTable
                     page = {page}
                     rowsPerPage={rowsPerPage}
                     props={ props}
                      count={userList}
                    />
                  </Grid>
                </Grid>
              ),
              Toolbar: props => (
                <Grid container justifyContent="flex-end">
                  <Grid item >
                    <Grid container justifyContent='center'>
                      <Grid item className={classes.label}>
                         <label style={{marginRight:'1rem'}}>{formatMessage({ id: 'customer.sort.by', defaultMessage: 'Sort by Customer' })}</label>
                     </Grid>
                     <Grid item style={{ paddingTop: 15 }}>
                    <SelectDropDown id="id" handleChange={onhandleChange} fieldName={'client'}
                      OptionsValueId={customer == undefined ? [] : customer}
                      selected={selected} ClassName={classes.select}
                      OptionsValue={[]} />
                     </Grid>
                      </Grid>
                  </Grid>
                  <Grid item>
                    <MTableToolbar {...props} />
                  </Grid>
                </Grid>
              )
            }}
          />
        </Panel>
      </Grid>
    </Container>
  )
}